const isDefined = (something) =>
  typeof something !== 'undefined' && something !== null;

export default isDefined;
